import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';

import { TableLazyLoadEvent } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { CaseService } from '../../case/services/case.services';
import { Router } from '@angular/router';
import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';
import { CaseStatusPipe } from '../../../shared/pipes/case-status.pipe';
import { AppointmentStatusPipe } from '../../../shared/pipes/appointment-status.pipe';

declare let FullCalendar: any;

@Component({
  selector: 'app-appointment-list',
  styleUrls: ['./appointment-list.component.scss'],
  templateUrl: './appointment-list.component.html',
})
export class AppointmentListComponent implements OnInit {
  viewType: 'list' | 'card' = 'list';

  searchText: string = '';
  calendarList: any[] = [];
  items: any[] = [];
  filterCollaps: boolean = false;

  totalRecords = 0;
  first = 0;
  rows = 20;
  currentPage: number = 1;
  itemsPerPage: number = 5; // Sayfa başına öğe sayısı
  allItems: any[] = []
  loading: boolean = false;

  calendar: any; // FullCalendar instance

  filter: {
    startDate: Date | null;
    searchTerm: string;
    caseTypes:any [],
    appointmentStatus:any
  } = {
    startDate: null,
    searchTerm: '',
    caseTypes:[],
    appointmentStatus:null

  };

  appointmentStatuses: { label: string; value: string }[] = [];
  caseTypes: Option[] = [];
  isVisible:boolean = false;
  statusLogsData: any = { logs: [] };
   processedLogs: any[] = [];
  loadingStatus: boolean = false;

  constructor(
    private readonly translate: TranslateService,
    private readonly appMessageService: AppMessageService,
    private readonly cdr: ChangeDetectorRef,
    private readonly caseService: CaseService,
    private readonly router: Router,
    private readonly parameterService: ParameterService,
    private readonly appointmentStatusPipe: AppointmentStatusPipe,
    private readonly caseStatusPipe: CaseStatusPipe

  ) {
    translate.setDefaultLang('tr'); // Set default language to Turkish
    translate.use('tr'); // Optionally, you can explicitly use Turkish
  }

  ngOnInit(): void {
    this.parameterService
    .getParameterValues('data-group', 'caseTypes')
    .subscribe((response) => {
      this.caseTypes = response.datas.values.map((data: any) => {
        return {label: data.valueObject.name.value, value: data.valueObject.id.value};
      });
    });
    this.appointmentStatuses = [
      {
        label: 'Randevu',
        value: 'started'
      },
      {
        label: 'İptal',
        value: 'canceled'
      },
      {
        label: 'Gerçekleşti',
        value: 'finished'
      }
    ];
  }

  async loadData(event: TableLazyLoadEvent, filter: object) {
    this.loading = true;

    if (this.allItems.length === 0) {
      this.caseService.getAppointmentList(filter).subscribe((data) => {

        this.allItems = data.items; // Tüm veriyi kopyalar
        this.totalRecords = data.total;

        this.applyPaginationAndSorting(event);
        this.loading = false;
      });
    } else {
      this.applyPaginationAndSorting(event);
      this.loading = false;
    }
  }

  applyPaginationAndSorting(event: TableLazyLoadEvent) {
    let processedData = [...this.allItems];

    if (event.sortField && event.sortOrder) {
      processedData = this.sortData(processedData, (event as any).sortField, event.sortOrder);
    }
    const first = event.first ?? 0;
    const rows = event.rows ?? 10;

    this.items = processedData.slice(first, first + rows);
    this.first = first;
    this.rows = rows;
  }

  sortData(data: any[], sortField: string, sortOrder: number): any[] {
    return data.sort((a, b) => {
      let aValue, bValue;

      switch (sortField) {
        case 'id':
          aValue = Number.parseInt(a.id);
          bValue = Number.parseInt(b.id);
          break;
        case 'firstName':
        case 'username':
          aValue = a.patientInformations?.firstName ?? '';
          bValue = b.patientInformations?.firstName ?? '';
          break;
        case 'lastName':
        case 'surname':
          aValue = a.patientInformations?.lastName ?? '';
          bValue = b.patientInformations?.lastName ?? '';
          break;
        case 'appointmentStartDate':
        case 'startDate':
          aValue = new Date(a.appointmentStartDate ?? 0);
          bValue = new Date(b.appointmentStartDate ?? 0);
          break;
        case 'appointmentStatus':
          aValue = a.appointmentStatus ?? '';
          bValue = b.appointmentStatus ?? '';
          break;
        case 'caseStatus':
          aValue = a.caseStatus ?? '';
          bValue = b.caseStatus ?? '';
          break;
        case 'caseType':
          aValue = a.caseType?.valueObject?.name?.value ?? '';
          bValue = b.caseType?.valueObject?.name?.value ?? '';
          break;
        case 'address':
          aValue = a.addressInformations?.pickupAddress?.formattedAddress ?? '';
          bValue = b.addressInformations?.pickupAddress?.formattedAddress ?? '';
          break;
        case 'patientNo':
          aValue = Number.parseInt(a.patientInformations?.id ?? 0);
          bValue = Number.parseInt(b.patientInformations?.id ?? 0);
          break;
        default:
          aValue = a[sortField] ?? '';
          bValue = b[sortField] ?? '';
      }

      let result = 0;
      if (aValue < bValue) result = -1;
      else if (aValue > bValue) result = 1;

      return sortOrder === 1 ? result : -result;
    });
  }

  refreshData(filter: object) {
    this.allItems = [];
    const resetEvent: TableLazyLoadEvent = {
      first: 0,
      rows: this.rows,
      sortField: undefined,
      sortOrder: undefined
    };
    this.loadData(resetEvent, filter);
  }

  clearFilter() {
    this.filter = {
      searchTerm: '',
      startDate: null,
      caseTypes:[],
      appointmentStatus:null
    };
    this.loadData({}, {});
  }

  getAppointmentStatusText(statusCode: string | null): string {
    return this.appointmentStatusPipe.transform(statusCode);
  }
  getCaseStatusText(statusCode: string | null): string {
    return this.caseStatusPipe.transform(statusCode);
  }

  initCalendar(events: any[] = []) {
    const initialLocaleCode = 'tr';
    const calendarEl = document.getElementById('calendar');
    if (this.calendar) {
      this.calendar.destroy();
    }

    const currentDate = new Date(); // Get the current date

    this.calendar = new FullCalendar.Calendar(calendarEl, {
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay',
      },
      locale: initialLocaleCode,
      selectable: true,
      selectMirror: true,
      slotLabelInterval: '01:00',
      slotDuration: '00:15:00',
      select: (arg: any) => {
        // Example event creation logic (commented out for now):
        // const title = prompt('Event Title:');
        // if (title) {
        //   this.calendar.addEvent({
        //     title: title,
        //     start: arg.start,
        //     end: arg.end,
        //     allDay: arg.allDay,
        //   });
        // }
        // this.calendar.unselect();
      },
      eventClick: (arg: any) => {
        const event = arg.event;
        const clickedItem = this.calendarList.find(
          (item: any) => item.id === Number(event.id)
        ); // Filter clicked item by event ID

        // open edit modal with the clicked event:
        this.showAppointmentDetail(clickedItem.id)

      },
      droppable: true,
      drop: (arg: any) => {
      },
      initialDate: currentDate.toISOString().split('T')[0], // Use current date as initialDate
      weekNumbers: true,
      navLinks: true, // can click day/week names to navigate views
      editable: true,
      nowIndicator: true,
      events: events,
    });
    this.calendar.render();
  }

  changeView(viewType: 'list' | 'card') {
    this.viewType = viewType;
    if (viewType === 'card') {
      this.loadEventsForCalendar({}, {}); // Load events when switching to card view
    }
    this.cdr.detectChanges(); // Force Angular to check for changes
  }

  loadEventsForCalendar(event: TableLazyLoadEvent, filter: object) {
    // Fetch events for the calendar
    this.caseService.getAppointmentList(filter).subscribe((data) => {
      this.calendarList = data.items.filter((i: any) => !i?.isDeleted);
      const events = data.items
        .filter((i: any) => !i?.isDeleted)
        .map((item: any) => {
          const startDate = new Date(item?.appointmentStartDate);
          const endDate = new Date(item?.appointmentEndDate);

          return {
            id: item.id,
            title:
              item?.id +
              ' - ' +
              item?.patientInformations?.firstName +
              ' ' +
              item?.patientInformations?.lastName,
            start: startDate.toISOString(), // Ensure proper format
            end: endDate.toISOString(), // Ensure proper format
            allDay: false, // Adjust based on your item structure
            backgroundColor: item?.caseType?.valueObject?.color?.value ?? '#087ff7ff',
            borderColor: item?.caseType?.valueObject?.color?.value ?? '#087ff7ff',
            textColor: '#000000',
          };
        });
      this.initCalendar(events);
    });
  }

  async getList(event: TableLazyLoadEvent) {
    this.loading = true;
    const filterObj = {
      search: this.filter.searchTerm,
      searchBy: [
        'appointment.patientInformations.firstName',
        'appointment.patientInformations.lastName',
      ],
      'filter.appointmentStartDate': this.filter?.startDate
        ? `${this.filter.startDate.toISOString()}`
        : null,
      caseTypes: this.filter.caseTypes,
      appointmentStatus: this.filter.appointmentStatus, 
    };

    this.totalRecords = 0;
    this.loading = true;

    this.caseService.getAppointmentList(filterObj).subscribe({
      next: (res) => {
        this.items = res.items;
        this.itemsPerPage = res.perPage;
        this.totalRecords = res.total;
        this.currentPage = res.currentPage;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  showAppointmentDetail(id:any){
  const url = this.router.serializeUrl(
        this.router.createUrlTree([`/case/${id}`], {
          queryParams: {
            fullscreen: true,
          },
        })
      );
      window.open(url, '_blank');
  }

   showStatusDetail(caseId: number) {
    this.loadingStatus = true;
    this.caseService.getLogs(caseId.toString()).subscribe((res: any) => {
      this.statusLogsData = res;
      if (!this.statusLogsData?.logs || this.statusLogsData.logs.length === 0) {
        this.loadingStatus = false;
        this.processedLogs = [];
        this.appMessageService.warningToast(
          "",
          this.translate.instant('appointment.nonStatusHistory')
        );
      } else {
        this.processedLogs = this.statusLogsData.logs.map((log: any, index: number) => {
          const previousLog = this.statusLogsData.logs[index + 1];

          return {
            ...log,
            previousStatus: previousLog ? previousLog.action : null,
            currentStatus: log.action
          };
        });
        this.loadingStatus = false
        this.isVisible = true;
      }
    });
  }

  showFieldSaleDetail(fieldSale: any) {
    if (!fieldSale?.id) {
      return;
    }

    window.open(
      `/field-sale/edit/${fieldSale.id}?isReadOnly=true`,
      '_blank'
    );
  }

  closeStatusLogsDialog() {
    this.isVisible = false;
    this.processedLogs = [];


  }
}
